import React, { useRef } from 'react';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { InventoryModel } from 'client/data/models/inventory';

export function withFacets(Component) {
  function WithFacets(props) {
    const { facets, selectedFilters, ...rest } = props;
    const prevFacetsRef = useRef(facets);

    // Only update the cached ref when facets are available; skip when undefined (model is loading)
    // to preserve the previous facets value for the stale-while-revalidate pattern below.
    if (facets !== undefined) {
      prevFacetsRef.current = facets;
    }

    // Stale-while-revalidate: pass the previous facets while new ones are being fetched
    // (facets === undefined means the model is loading), preventing a UI flash on navigation.
    return <Component {...rest} facets={facets === undefined ? prevFacetsRef.current : facets} />;
  }

  WithFacets.displayName = `withFacets(${Component.displayName || Component.name})`;

  return connectToModel(
    connectToModel(WithFacets, {
      // Presence of `selectedFilters` check is needed for noss mode only, because preload function, which sets filters, executes a bit later and withFacets hoc will try to resolve facets path with undefined selectedFilters. Inventory model will do context.abort() in the "facetsSplit" path and facets will never get resolved on the client.
      // In SSR mode selectedFilters will always present, because fetchFacets is set to false in the preload function and context.abort() will never be called. In noss mode fetchFacets is true and context.abort() will be called if selectedFilters is undefined, so we need to handle this case in the hoc.
      facets: bindToPath(({ selectedFilters }) => selectedFilters && 'facetsSplit', InventoryModel, null, false),
    }),
    {
      selectedFilters: bindToPath('searchResultsFilter', InventoryModel, null, false),
    }
  );
}
